<section class="container">
  <h1>How can we help you?</h1>
  <div class="audience-list row" *ngIf="audienceList$ | async as collection; else loading">
    <div class="col-xs-12 col-sm-6 col-md-6 col-lg-4 col-xl-4" *ngFor="let a of collection['hydra:member']">
      <a routerLink="/menu/{{a.slug}}" class="audience box" [class.unpublished]="!a.published">
        <section>
          <h2>{{a.name}}</h2>
          <p>{{a.description}}</p>
        </section>
        <!--<picture>
          <img src="{{a.image}}" alt="{{a.imageAlt}}"/>
        </picture>-->
        <picture *ngIf="a.image">
          <source srcset="{{a.image.webp}}" type="image/webp">
          <img src="{{a.image.jpg}}" alt="{{a.name}} Image" type="image/jpg"/>
        </picture>
      </a>
    </div>
    <div class="col-xs-12 col-sm-6 col-md-6 col-lg-4 col-xl-4">
      <a href="https://dining.umich.edu/catering/catering-to-go/" class="audience box">
        <section>
          <h2>{{diningToGo.title}}</h2>
          <p>{{diningToGo.description}}</p>
        </section>
        <picture>
          <img src="{{diningToGo.image}}" alt="{{diningToGo.imageAlt}}"/>
        </picture>
      </a>
    </div>
  </div>
  <ng-template #loading>
    <mat-spinner></mat-spinner>
  </ng-template>
</section>
